export default __webpack_public_path__ + "static/cta-dont-3fcec49124e3abf419f3e9de2a20bb2c.png";